import EventRepository from '@/repositories/EventRepository'
import PagerRepository from '@/repositories/PagerRepository'
import SnapsnapGateway from '@/gateways/SnapsnapGateway'
import FetchOrderItemsByPhotosUseCase from '@/usecases/orderItem/FetchOrderItemsByPhotosUseCase'
import { pluck } from '@/utils/helper'

export interface IFetchAlbumPhotosUseCaseParams {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway
  pagerRepository: PagerRepository
  fetchOrderItemsByPhotosUseCase: FetchOrderItemsByPhotosUseCase
}

export default class FetchAlbumPhotosUseCase implements BaseUseCase {
  eventRepository: EventRepository
  snapsnapGateway: SnapsnapGateway
  pagerRepository: PagerRepository
  fetchOrderItemsByPhotosUseCase: FetchOrderItemsByPhotosUseCase

  constructor({ eventRepository, snapsnapGateway, pagerRepository, fetchOrderItemsByPhotosUseCase }: IFetchAlbumPhotosUseCaseParams) {
    this.eventRepository = eventRepository
    this.snapsnapGateway = snapsnapGateway
    this.pagerRepository = pagerRepository
    this.fetchOrderItemsByPhotosUseCase = fetchOrderItemsByPhotosUseCase
  }

  /**
   * 1. 任意のアルバムページに存在する写真の一覧を取得
   * 2. 任意の写真が含まれるアルバムページを取得
   * 3. 取得した写真一覧の購入履歴を取得
   *
   * という3つの責務がある
   */
  async execute(params: { eventId: number; albumId: number; page?: number; include?: number }) {
    try {
      const { eventId, albumId } = params
      const { photos, total, currentPage } = await this.snapsnapGateway.Album.getAlbumPhotos(params)
      const ids = photos.map(photo => photo.id)
      this.eventRepository.savePhotosByPage({ eventId, albumId, page: currentPage, photos })
      this.pagerRepository.updatePhotosPager({ eventId, albumId, pager: { total, page: currentPage } })

      const orderItems = await this.fetchOrderItemsByPhotosUseCase.execute({ eventId, photoIds: pluck(photos, 'id') })

      return {
        page: currentPage,
        orderItems,
        pageInPhotoIds: ids
      }
    } catch (error) {
      throw error
    }
  }
}
